import { QueryKeys } from "@app/constants/query-keys.ts";
import { useApis } from "@app/data/apis.ts";
import { useQuery } from "bi-lib";

interface Props {
    assignmentId?: number;
    staffIds?: number[];
}

export function useAssignmentBudgetChartsData({ assignmentId, staffIds }: Props = {}) {
    const apis = useApis();

    const chartDataQuery = useQuery({
        queryKey: [QueryKeys.AssignmentBudgetChartsData, { assignmentId, staffIds }],
        queryFn: () =>
            apis.engine.assignment.assignmentBudgetChartsDetail(assignmentId!, {
                staffIds: staffIds?.map((id) => id.toString()),
            }),
        enabled: assignmentId != undefined,
    });

    return {
        chartData: chartDataQuery,
    };
}
